import { backendBookartUrl } from "../library/constants";
import axios from "axios";

export async function validateJWTtoken(token) {
    try {
        const resp = await axios.get(`${backendBookartUrl}/tokenvalidation`, {
            params: {
                token: token,
            },
        });
        // Check if the response structure is as expected
        if (resp.data && typeof resp.data.token_valid === 'boolean') {
            return resp.data.token_valid;
        } else {
            console.error('Unexpected response structure:', resp.data);
            return false;
        }
    } catch (e) {
        // Log error details for debugging
        if (e.response) {
            // The request was made and the server responded with a status code
            console.error('Error response data:', e.response.data);
            console.error('Error response status:', e.response.status);
        } else if (e.request) {
            // The request was made but no response was received
            console.error('Error request:', e.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.error('Error message:', e.message);
        }
        return false;
    }
}

export async function adminValidation(navigate) {
    try {
        const email = window.sessionStorage.getItem("emailId");
        const token = window.sessionStorage.getItem("JWTtoken");
        
        if (!email) {
            console.warn('No email found in session storage.');
            return false; // Early return if no email is found
        }

        const configAdmin = {
            method: 'get',
            url: `${backendBookartUrl}/validateAdmin`,
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        };
        const response = await axios(configAdmin); // Await the API call
        // if (response.data && response.data.isAdmin === "true") {
        //     console.log(response);
        //     return true; // Return true if isAdmin is "true"
        // } else {
        //     console.error('Unexpected response structure:', response.data);
        //     console.log(response)
        //     return false; // Return false for unexpected response
        // }
        return response
    } catch (e) {
        // Log error details for debugging
        if (e.response) {
            console.error('Error response data:', e.response.data);
            console.error('Error response status:', e.response.status);
        } else if (e.request) {
            console.error('Error request:', e.request);
        } else if ( e.response.status === 401) {
            console.error('Error message:', e.msg);
        }
          else {
            console.error('Error message:', e.message);
        }
        return false; // Return false on error
    }
}